import _ from 'lodash';
import CellModel from '../models/CellModel';

export default class DebugDataSetMaker {
    static makeWild()
    {
        let cellModels = [];
        let slotIndex = _.random(0, 4);
        for (let i = 0; i < 5; i++)
        {
            if (i === slotIndex)
            {
                // Make extra cells
                let extraSets = [
                    [
                        new CellModel({ symbol: 'guy', slotIndex: i, cellIndex: 0 }),
                        new CellModel({ symbol: 'raki', slotIndex: i, cellIndex: 1 }),
                        new CellModel({ symbol: 'glasses', slotIndex: i, cellIndex: 2 })
                    ],
                    [
                        new CellModel({ symbol: 'singer', slotIndex: i, cellIndex: 0 }),
                        new CellModel({ symbol: 'diamond', slotIndex: i, cellIndex: 1 }),
                        new CellModel({ symbol: 'microphone', slotIndex: i, cellIndex: 2 })
                    ],
                    [
                        new CellModel({ symbol: 'old', slotIndex: i, cellIndex: 0 }),
                        new CellModel({ symbol: 'ring', slotIndex: i, cellIndex: 1 }),
                        new CellModel({ symbol: 'teshib', slotIndex: i, cellIndex: 2 })
                    ]
                ];

                let setIndex = _.random(0, 2);
                extraSets[setIndex].forEach((model) =>
                {
                    cellModels.push(model);
                });
            }
            else
            {
                // Make regular cells
                for (let j = 0; j < 3; j++)
                {
                    let cellModel = new CellModel({
                        symbol: _.sample([
                            'bonus', 'diamond', 'glasses', 'microphone', 'raki', 'ring', 'teshib',
                            'guy', 'singer', 'old'
                        ]),
                        slotIndex: i,
                        cellIndex: j
                    });
                    cellModels.push(cellModel);
                }
            }
        }

        return cellModels;
    }

    static makeNudging(type = 'down-to-top')
    {
        let cellModels = [];
        let slotIndex = 0;
        for (let i = 0; i < 5; i++)
        {
            if (i === slotIndex)
            {
                // Make extra cells
                let extraSets = [
                    [
                        new CellModel({ symbol: 'guy', slotIndex: i, cellIndex: 0 }),
                        new CellModel({ symbol: 'raki', slotIndex: i, cellIndex: 1 }),
                        new CellModel({ symbol: 'glasses', slotIndex: i, cellIndex: 2 })
                    ],
                    [
                        new CellModel({ symbol: 'singer', slotIndex: i, cellIndex: 0 }),
                        new CellModel({ symbol: 'diamond', slotIndex: i, cellIndex: 1 }),
                        new CellModel({ symbol: 'microphone', slotIndex: i, cellIndex: 2 })
                    ],
                    [
                        new CellModel({ symbol: 'old', slotIndex: i, cellIndex: 0 }),
                        new CellModel({ symbol: 'ring', slotIndex: i, cellIndex: 1 }),
                        new CellModel({ symbol: 'teshib', slotIndex: i, cellIndex: 2 })
                    ]
                ];

                let setIndex = _.random(0, 2);
                extraSets[setIndex].forEach((model) =>
                {
                    cellModels.push(model);
                });

                let additionalCellModel = new CellModel({
                    symbol: _.sample([
                        'bonus', 'diamond', 'glasses', 'microphone', 'raki', 'ring', 'teshib',
                        'guy', 'singer', 'old'
                    ]),
                    slotIndex: i,
                    cellIndex: type === 'down-to-top' ? -1 : 3
                });
                cellModels.push(additionalCellModel);
            }
            else
            {
                // Make regular cells
                for (let j = 0; j < 3; j++)
                {
                    let cellModel = new CellModel({
                        symbol: _.sample([
                            'bonus', 'diamond', 'glasses', 'microphone', 'raki', 'ring', 'teshib',
                            'guy', 'singer', 'old'
                        ]),
                        slotIndex: i,
                        cellIndex: j
                    });
                    cellModels.push(cellModel);
                }
            }
        }

        return cellModels;
    }

    static makeScatter()
    {
        let cellModels = [];
        let slotIndexes = [0, 1, 2, 3, 4].sort(() => 0.5 - Math.random()).slice(0, _.random(2, 3));
        for (let i = 0; i < 5; i++)
        {
            if (slotIndexes.indexOf(i) !== -1)
            {
                // Make extra cells
                let extraSets = [
                    [
                        new CellModel({ symbol: 'guy', slotIndex: i, cellIndex: 0 }),
                        new CellModel({ symbol: 'raki', slotIndex: i, cellIndex: 1 }),
                        new CellModel({ symbol: 'glasses', slotIndex: i, cellIndex: 2 })
                    ],
                    [
                        new CellModel({ symbol: 'singer', slotIndex: i, cellIndex: 0 }),
                        new CellModel({ symbol: 'diamond', slotIndex: i, cellIndex: 1 }),
                        new CellModel({ symbol: 'microphone', slotIndex: i, cellIndex: 2 })
                    ],
                    [
                        new CellModel({ symbol: 'old', slotIndex: i, cellIndex: 0 }),
                        new CellModel({ symbol: 'ring', slotIndex: i, cellIndex: 1 }),
                        new CellModel({ symbol: 'teshib', slotIndex: i, cellIndex: 2 })
                    ]
                ];

                let setIndex = _.random(0, 2);
                extraSets[setIndex].forEach((model) =>
                {
                    cellModels.push(model);
                });
            }
            else
            {
                // Make regular cells
                for (let j = 0; j < 3; j++)
                {
                    let cellModel = new CellModel({
                        symbol: _.sample([
                            'bonus', 'diamond', 'glasses', 'microphone', 'raki', 'ring', 'teshib',
                            'guy', 'singer', 'old'
                        ]),
                        slotIndex: i,
                        cellIndex: j
                    });
                    cellModels.push(cellModel);
                }
            }
        }

        return cellModels;
    }

    static makeRandom()
    {
        let cellModels = [];
        for (let i = 0; i < 5; i++)
        {
            // Make regular cells
            for (let j = 0; j < 3; j++)
            {
                let cellModel = new CellModel({
                    symbol: _.sample([
                        'bonus', 'diamond', 'glasses', 'microphone', 'raki', 'ring', 'teshib',
                        'guy', 'singer', 'old'
                    ]),
                    slotIndex: i,
                    cellIndex: j
                });
                cellModels.push(cellModel);
            }
        }

        return cellModels;
    }

    static makeFreeSpins()
    {
        let cellModels = [];
        for (let i = 0; i < 5; i++)
        {
            // Make regular cells
            for (let j = 0; j < 3; j++)
            {
                let cellModel = new CellModel({
                    symbol: _.sample([
                        'diamond', 'glasses', 'microphone', 'raki', 'ring', 'teshib',
                        'guy', 'singer', 'old'
                    ]),
                    slotIndex: i,
                    cellIndex: j
                });
                cellModels.push(cellModel);
            }
        }

        const highlightConditions = [
            (cell) => cell.slotIndex === 1 && cell.cellIndex === 1,
            (cell) => cell.slotIndex === 2 && cell.cellIndex === 1,
            (cell) => cell.slotIndex === 3 && cell.cellIndex === 1
        ];

        cellModels.forEach((cell) =>
        {
            cell.highlight = highlightConditions.some((condition) => condition(cell));
            if (cell.highlight)
            {
                cell.symbol = 'bonus';
            }
        });


        return cellModels;
    }

    static makeBonusLines()
    {
        let cellModels = [];
        for (let i = 0; i < 5; i++)
        {
            // Make regular cells
            for (let j = 0; j < 3; j++)
            {
                let cellModel = new CellModel({
                    symbol: _.sample([
                        'diamond', 'glasses', 'microphone', 'raki', 'ring', 'teshib',
                        'guy', 'singer', 'old'
                    ]),
                    slotIndex: i,
                    cellIndex: j
                });
                cellModels.push(cellModel);
            }
        }

        const highlightConditions = [
            (cell) => cell.slotIndex === 0 && cell.cellIndex === 2,
            (cell) => cell.slotIndex === 2 && cell.cellIndex === 2,
            (cell) => cell.slotIndex === 4 && cell.cellIndex === 1
        ];

        cellModels.forEach((cell) =>
        {
            cell.highlight = highlightConditions.some((condition) => condition(cell));
            if (cell.highlight)
            {
                cell.symbol = 'bonus';
            }
        });

        return cellModels;
    }

    static makeBigWin()
    {
        let cellModels = [];
        let slotIndexes = [1, 2, 3];
        let setIndex = _.random(0, 2);
        for (let i = 0; i < 5; i++)
        {
            if (slotIndexes.indexOf(i) !== -1)
            {
                // Make extra cells
                let extraSets = [
                    [
                        new CellModel({ symbol: 'guy', slotIndex: i, cellIndex: 0 }),
                        new CellModel({ symbol: 'raki', slotIndex: i, cellIndex: 1 }),
                        new CellModel({ symbol: 'glasses', slotIndex: i, cellIndex: 2 })
                    ],
                    [
                        new CellModel({ symbol: 'singer', slotIndex: i, cellIndex: 0 }),
                        new CellModel({ symbol: 'diamond', slotIndex: i, cellIndex: 1 }),
                        new CellModel({ symbol: 'microphone', slotIndex: i, cellIndex: 2 })
                    ],
                    [
                        new CellModel({ symbol: 'old', slotIndex: i, cellIndex: 0 }),
                        new CellModel({ symbol: 'ring', slotIndex: i, cellIndex: 1 }),
                        new CellModel({ symbol: 'teshib', slotIndex: i, cellIndex: 2 })
                    ]
                ];

                extraSets[setIndex].forEach((model) =>
                {
                    cellModels.push(model);
                });
            }
            else
            {
                // Make regular cells
                for (let j = 0; j < 3; j++)
                {
                    let cellModel = new CellModel({
                        symbol: _.sample([
                            'bonus', 'diamond', 'glasses', 'microphone', 'raki', 'ring', 'teshib',
                            'guy', 'singer', 'old'
                        ]),
                        slotIndex: i,
                        cellIndex: j
                    });
                    cellModels.push(cellModel);
                }
            }
        }

        return cellModels;
    }

    static make2Characters()
    {
        let cellModels = [];
        let slotIndexes = [0, 1, 2, 3, 4].sort(() => 0.5 - Math.random()).slice(0, 2);
        let setIndexes = [0, 1, 2].sort(() => 0.5 - Math.random()).slice(0, 2);
        for (let i = 0; i < 5; i++)
        {
            if (slotIndexes.indexOf(i) !== -1 && setIndexes.length)
            {
                // Make extra cells
                let extraSets = [
                    [
                        new CellModel({ symbol: 'guy', slotIndex: i, cellIndex: 0 }),
                        new CellModel({ symbol: 'raki', slotIndex: i, cellIndex: 1 }),
                        new CellModel({ symbol: 'glasses', slotIndex: i, cellIndex: 2 })
                    ],
                    [
                        new CellModel({ symbol: 'singer', slotIndex: i, cellIndex: 0 }),
                        new CellModel({ symbol: 'diamond', slotIndex: i, cellIndex: 1 }),
                        new CellModel({ symbol: 'microphone', slotIndex: i, cellIndex: 2 })
                    ],
                    [
                        new CellModel({ symbol: 'old', slotIndex: i, cellIndex: 0 }),
                        new CellModel({ symbol: 'ring', slotIndex: i, cellIndex: 1 }),
                        new CellModel({ symbol: 'teshib', slotIndex: i, cellIndex: 2 })
                    ]
                ];

                let setIndex = setIndexes.shift();
                extraSets[setIndex].forEach((model) =>
                {
                    cellModels.push(model);
                });
            }
            else
            {
                // Make regular cells
                for (let j = 0; j < 3; j++)
                {
                    let cellModel = new CellModel({
                        symbol: _.sample([
                            'bonus', 'diamond', 'glasses', 'microphone', 'raki', 'ring', 'teshib',
                            'guy', 'singer', 'old'
                        ]),
                        slotIndex: i,
                        cellIndex: j
                    });
                    cellModels.push(cellModel);
                }
            }
        }

        return cellModels;
    }

    static makeHigh()
    {
        let cellModels = [];
        let slotIndexes = [3, 4];
        let setIndexes = [0, 1, 2].sort(() => 0.5 - Math.random()).slice(0, 2);
        for (let i = 0; i < 5; i++)
        {
            if (slotIndexes.indexOf(i) !== -1 && setIndexes.length)
            {
                // Make extra cells
                let extraSets = [
                    [
                        new CellModel({ symbol: 'guy', slotIndex: i, cellIndex: 0, highlight: true }),
                        new CellModel({ symbol: 'raki', slotIndex: i, cellIndex: 1 }),
                        new CellModel({ symbol: 'glasses', slotIndex: i, cellIndex: 2 })
                    ],
                    [
                        new CellModel({ symbol: 'singer', slotIndex: i, cellIndex: 0, highlight: true }),
                        new CellModel({ symbol: 'diamond', slotIndex: i, cellIndex: 1 }),
                        new CellModel({ symbol: 'microphone', slotIndex: i, cellIndex: 2 })
                    ],
                    [
                        new CellModel({ symbol: 'old', slotIndex: i, cellIndex: 0, highlight: true }),
                        new CellModel({ symbol: 'ring', slotIndex: i, cellIndex: 1 }),
                        new CellModel({ symbol: 'teshib', slotIndex: i, cellIndex: 2 })
                    ]
                ];

                let setIndex = setIndexes.shift();
                extraSets[setIndex].forEach((model) =>
                {
                    cellModels.push(model);
                });
            }
            else
            {
                // Make regular cells
                for (let j = 0; j < 3; j++)
                {
                    let cellModel = new CellModel({
                        symbol: _.sample([
                            'bonus', 'diamond', 'glasses', 'microphone', 'raki', 'ring', 'teshib',
                            'guy', 'singer', 'old'
                        ]),
                        slotIndex: i,
                        cellIndex: j
                    });
                    cellModels.push(cellModel);

                    if (cellModel.slotIndex)
                    cellModel.highlight
                }
            }
        }

        const highlightConditions = [
            (cell) => cell.slotIndex === 0 && cell.cellIndex === 2,
            (cell) => cell.slotIndex === 1 && cell.cellIndex === 0,
            (cell) => cell.slotIndex === 2 && cell.cellIndex === 0,
            (cell) => cell.slotIndex === 3 && cell.cellIndex === 0,
            (cell) => cell.slotIndex === 4 && cell.cellIndex === 2
        ];

        cellModels.forEach((cell) =>
        {
            cell.highlight = highlightConditions.some((condition) => condition(cell));
        });

        return cellModels;
    }
}